import { useState, useEffect, useContext } from 'react'
import { appContext } from "./../../AppContext";
//Hooks
import { useTranslation } from 'react-i18next'


export function useErrorMessage(initialValue)
{
    const [appState] = useContext(appContext);

    const [returnMessage, setReturnMessage] = useState(initialValue)
    const [error, setError] = useState(undefined)
    const { t } = useTranslation(['login'])

    useEffect(() => {
        if(error === undefined) {
            setReturnMessage(undefined)
            return;
        }
        switch(error)
        {
            case "error.empty_username":
            case "error.empty_password":
            case "error.invalid_credentials":
                setReturnMessage(t("error.invalidCredentials"))
                break;
            case "error.password_not_the_Same":
                setReturnMessage(t("resetPassword.notSamePassword"))
                break;
            case "error.password_missing_policies":
                setReturnMessage(t("resetPassword.notPasswordPolicyApproved"))
                break;
            case "error.invalid_username":
                setReturnMessage(t("forgotPassword.invalidUsername"))
                break;
            case "error.contains_same_password":
                setReturnMessage(t("resetPassword.passwordSameAsPrevious"))
                break;
            case "error.locked_out":
                setReturnMessage(`${t("error.lockedOut")} (${appState.lockoutTime})`)
                break;    
            case "error.invalid_returnurl":
            case "error.empty_data":
            default:
                if(error.message === undefined)
                {
                    setReturnMessage(t("error.generalError")) 
                    break;
                }
                setReturnMessage(t("error.generalError") + " ErrorCode= " + error.message)
        }
    },
    //eslint-disable-next-line
    [error, t])


    return [returnMessage, setError]
}